import { EventEmitter, TemplateRef, Directive, ElementRef, ComponentFactoryResolver, ApplicationRef, Injector, Renderer2, Input, Output, HostListener, NgModule } from '@angular/core';
import { AwTooltipComponent, AwTooltipModule } from '@aw/ads-components/aw-tooltip';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
const defaultOptions = {
    placement: 'top',
    automationValue: 'tooltipComponent',
    hideAfterClick: false,
    autoPlacement: true,
    contentType: 'string',
    showDelay: 0,
    hideDelay: 300,
    hideDelayMobile: 0,
    hideDelayTouchscreen: 0,
    zIndex: 0,
    animationDuration: 300,
    trigger: 'hover',
    tooltipClass: '',
    display: true,
    displayTouchscreen: true,
    offset: 8,
    maxWidth: 200,
    hideDelayAfterClick: 2000
};

const ɵ0 = () => { }, ɵ1 = () => { }, ɵ2 = () => { }, ɵ3 = () => { }, ɵ4 = () => { }, ɵ5 = (event) => !event;
const windowMatchObj = {
    matches: false,
    media: '',
    onchange: ɵ0,
    addListener: ɵ1,
    removeListener: ɵ2,
    addEventListener: ɵ3,
    removeEventListener: ɵ4,
    dispatchEvent: ɵ5
};
window.matchMedia = window.matchMedia || (() => windowMatchObj);
class AwTooltipDirective {
    constructor(elementRef, componentFactoryResolver, appRef, injector, render) {
        this.elementRef = elementRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.render = render;
        this._showDelay = 0;
        this._hideDelay = 300;
        this._options = {};
        this.tooltipType = 'tooltip';
        this.events = new EventEmitter();
        this.options = defaultOptions;
        this.hideTooltipSubject = new Subject();
    }
    set options(value) {
        if (value && defaultOptions) {
            this._options = value;
        }
    }
    get options() {
        return this._options;
    }
    get isTooltipDestroyed() {
        return this.componentRef && this.componentRef.hostView.destroyed;
    }
    get destroyDelay() {
        if (this._destroyDelay) {
            return this._destroyDelay;
        }
        return Number(this.getHideDelay()) + Number(this.options.animationDuration);
    }
    set destroyDelay(value) {
        this._destroyDelay = value;
    }
    get tooltipPosition() {
        if (this.options.position) {
            return this.options.position;
        }
        return this.elementPosition;
    }
    get element() {
        const isSvg = this.elementRef instanceof SVGElement;
        let host = this.elementRef;
        const hostEl = this.elementRef.nativeElement;
        const elementHeight = isSvg
            ? hostEl.getBoundingClientRect().height
            : hostEl.offsetHeight;
        const elementChildren = hostEl.children;
        if (elementChildren.length) {
            elementChildren.forEach = [].forEach;
            elementChildren.forEach((child) => {
                const h = child instanceof SVGElement
                    ? child.getBoundingClientRect().height
                    : child.offsetHeight;
                if (h > elementHeight) {
                    host = child;
                }
            });
        }
        return host;
    }
    ngOnChanges(changes) {
        const changedOptions = this.getProperties(changes);
        this.applyOptionsDefault(defaultOptions, changedOptions);
    }
    ngAfterViewInit() {
        if (this.isTouchScreen) {
            this.renderTooltipForTouchScreens();
        }
        this.addWCAGDescriptions(this.tooltipValue, this.tooltipId);
    }
    ngOnDestroy() {
        this.destroyTooltip({
            fast: true,
            destroyComponent: true
        });
        if (this.componentSubscribe) {
            this.componentSubscribe.unsubscribe();
        }
        this.hideTooltipSubject.complete();
    }
    getShowDelay() {
        return this.options.showDelay;
    }
    getHideDelay() {
        const { hideDelay } = this.options;
        const { hideDelayTouchscreen } = this.options;
        return this.isTouchScreen ? hideDelayTouchscreen : hideDelay;
    }
    getProperties(changes) {
        let properties = {};
        Object.keys(changes).forEach((prop) => {
            if (prop !== 'options' && prop !== 'tooltipValue') {
                properties[prop] = changes[prop].currentValue;
            }
            if (prop === 'options') {
                properties = changes[prop].currentValue;
            }
        });
        return properties;
    }
    getElementPosition() {
        this.elementPosition = this.element.nativeElement
            ? this.element.nativeElement.getBoundingClientRect()
            : this.element.getBoundingClientRect();
    }
    createTooltip() {
        if (!this.tooltipValue || (typeof this.tooltipValue === 'string' && this.tooltipValue.trim() === '')) {
            return;
        }
        this.clearTimeouts();
        this.getElementPosition();
        this.createTimeoutId = window.setTimeout(() => {
            this.appendComponentToBody(AwTooltipComponent);
        }, this.getShowDelay());
        this.showTimeoutId = window.setTimeout(() => {
            this.showTooltipElem();
        }, this.getShowDelay());
    }
    destroyTooltip(options = {
        fast: false,
        destroyComponent: true
    }) {
        this.clearTimeouts();
        if (this.isTooltipDestroyed === false) {
            this.hideTimeoutId = window.setTimeout(() => {
                this.hideTooltip();
            }, options.fast ? 0 : this.getHideDelay());
            this.destroyTimeoutId = window.setTimeout(() => {
                if (!this.componentRef || this.isTooltipDestroyed) {
                    return;
                }
                if (options.destroyComponent) {
                    this.appRef.detachView(this.componentRef.hostView);
                    this.componentRef.destroy();
                }
                this.events.emit({
                    type: 'hidden',
                    position: this.tooltipPosition
                });
            }, options.fast ? 0 : this.destroyDelay);
        }
    }
    showTooltipElem(recalculateElPositionAndOpenTooltip) {
        this.addCloseListeners();
        this.clearTimeouts();
        this.componentRef.instance.show = true;
        if (recalculateElPositionAndOpenTooltip) {
            this.recalculateElPositionAndOpenTooltip();
        }
        this.events.emit({
            type: 'show',
            position: this.tooltipPosition
        });
    }
    hideTooltip() {
        if (!this.componentRef || this.isTooltipDestroyed) {
            return;
        }
        this.componentRef.instance.show = false;
        this.events.emit({
            type: 'hide',
            position: this.tooltipPosition
        });
    }
    appendComponentToBody(component) {
        this.componentRef = this.componentFactoryResolver
            .resolveComponentFactory(component)
            .create(this.injector);
        this.componentRef.instance.data = {
            value: this.tooltipValue,
            element: this.elementRef.nativeElement,
            elementPosition: this.tooltipPosition,
            options: this.options
        };
        this.componentRef.instance.elementId = this.tooltipId;
        this.componentRef.instance.tooltipType = this.tooltipType;
        this.appRef.attachView(this.componentRef.hostView);
        const domElem = this.componentRef.hostView
            .rootNodes[0];
        this.containerToAppend.appendChild(domElem);
        this.componentSubscribe = this.componentRef.instance
            .events.subscribe((event) => {
            this.handleEvents(event);
        });
    }
    clearTimeouts() {
        if (this.createTimeoutId) {
            clearTimeout(this.createTimeoutId);
        }
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
        }
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
        }
        if (this.destroyTimeoutId) {
            clearTimeout(this.destroyTimeoutId);
        }
    }
    get isDisplayOnHover() {
        if (this.options.display === false) {
            return false;
        }
        if (this.options.displayTouchscreen === false && this.isTouchScreen) {
            return false;
        }
        if (this.options.trigger !== 'hover') {
            return false;
        }
        return true;
    }
    get isDisplayOnClick() {
        if (this.options.display === false) {
            return false;
        }
        if (this.options.displayTouchscreen === false && this.isTouchScreen) {
            return false;
        }
        if (this.options.trigger !== 'click') {
            return false;
        }
        return true;
    }
    get isTouchScreen() {
        const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        const mq = (query) => window.matchMedia(query).matches;
        if (('ontouchstart' in window)) {
            return true;
        }
        const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }
    applyOptionsDefault(defaultOpt, options) {
        this.options = Object.assign(Object.assign(Object.assign({}, defaultOpt), this.options), options);
    }
    handleEvents(event) {
        if (event.type === 'shown') {
            this.events.emit({
                type: 'shown',
                position: this.tooltipPosition
            });
        }
    }
    show() {
        if (this.hideTooltipSubject.observers.length !== 0) {
            return;
        }
        if (!this.componentRef || this.isTooltipDestroyed) {
            this.createTooltip();
        }
        else if (!this.isTooltipDestroyed) {
            this.showTooltipElem(this.isTouchScreen);
        }
    }
    hide() {
        const destroyComponent = !this.isTouchScreen;
        this.destroyTooltip({ fast: false, destroyComponent });
        this.hideTooltipSubject.next(true);
    }
    renderTooltipForTouchScreens() {
        this.createTooltip();
        setTimeout(() => {
            this.hide();
        }, this.getShowDelay());
    }
    addCloseListeners() {
        const keyDown = this.render.listen('window', 'keydown.esc', () => {
            this.hide();
        });
        const focusout = this.render.listen('window', 'focusout', () => {
            this.hide();
        });
        const click = this.render.listen('window', 'click', (event) => {
            const path = event.composedPath ? event.composedPath() : event.path;
            const eventIsOnDirectiveEl = path.find((element) => element === this.elementRef.nativeElement);
            const eventIsOnTooltipEl = path.find((el) => el === this.componentRef.instance.elementRef.nativeElement);
            if (!(eventIsOnDirectiveEl || eventIsOnTooltipEl)) {
                this.hide();
            }
        });
        const subscription = this.hideTooltipSubject.subscribe(() => {
            keyDown();
            click();
            focusout();
            subscription.unsubscribe();
            window.__aw__tooltip_close_handler = undefined;
        });
        if (window.__aw__tooltip_close_handler) {
            window.__aw__tooltip_close_handler();
        }
        window.__aw__tooltip_close_handler = () => {
            this.hide();
        };
    }
    get containerToAppend() {
        if (!this.tooltipContainer) {
            return document.body;
        }
        if (typeof this.tooltipContainer === 'string') {
            return document.querySelector(this.tooltipContainer) || document.body;
        }
        return this.tooltipContainer.nativeElement || this.tooltipContainer || document.body;
    }
    recalculateElPositionAndOpenTooltip() {
        this.getElementPosition();
        this.componentRef.instance.data.elementPosition = this.tooltipPosition;
        this.componentRef.instance.setPosition();
        this.componentRef.instance.setAnimationStatusToOpen();
    }
    addWCAGDescriptions(tooltip, id) {
        if (tooltip && id) {
            const el = document.createElement('div');
            el.id = id;
            let v;
            if (tooltip instanceof TemplateRef) {
                const view = tooltip.createEmbeddedView({});
                view.detectChanges();
                v = view.rootNodes[0].outerHTML;
            }
            else {
                v = tooltip;
            }
            el.innerHTML = v;
            el.className = 'visuallyhidden';
            el.setAttribute('aria-hidden', 'true');
            el.setAttribute('automation', 'tooltip-wcag-description');
            this.elementRef.nativeElement.after(el);
        }
    }
}
AwTooltipDirective.ɵfac = function AwTooltipDirective_Factory(t) { return new (t || AwTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
AwTooltipDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwTooltipDirective, selectors: [["", "aw-tooltip", ""]], inputs: { options: "options", tooltipValue: ["aw-tooltip", "tooltipValue"], placement: "placement", autoPlacement: ["auto-placement", "autoPlacement"], contentType: ["content-type", "contentType"], hideDelayMobile: ["hide-delay-mobile", "hideDelayMobile"], hideDelayTouchscreen: ["hide-delay-touchscreen", "hideDelayTouchscreen"], zIndex: ["z-index", "zIndex"], animationDuration: ["animation-duration", "animationDuration"], trigger: "trigger", tooltipClass: ["tooltip-class", "tooltipClass"], display: "display", displayTouchscreen: ["display-touchscreen", "displayTouchscreen"], offset: "offset", width: "width", maxWidth: ["max-width", "maxWidth"], hideAfterClick: ["hide-after-click", "hideAfterClick"], showDelay: ["show-delay", "showDelay"], hideDelay: ["hide-delay", "hideDelay"], hideDelayAfterClick: ["hide-delay-after-click", "hideDelayAfterClick"], automationValue: ["tooltip-automation-value", "automationValue"], pointerEvents: ["pointer-events", "pointerEvents"], position: "position", tooltipId: ["tooltip-id", "tooltipId"], tooltipContainer: ["tooltip-container", "tooltipContainer"] }, outputs: { events: "events" }, exportAs: ["aw-tooltip"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
AwTooltipDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector },
    { type: Renderer2 }
];
AwTooltipDirective.propDecorators = {
    options: [{ type: Input, args: ['options',] }],
    tooltipValue: [{ type: Input, args: ['aw-tooltip',] }],
    placement: [{ type: Input, args: ['placement',] }],
    autoPlacement: [{ type: Input, args: ['auto-placement',] }],
    contentType: [{ type: Input, args: ['content-type',] }],
    hideDelayMobile: [{ type: Input, args: ['hide-delay-mobile',] }],
    hideDelayTouchscreen: [{ type: Input, args: ['hide-delay-touchscreen',] }],
    zIndex: [{ type: Input, args: ['z-index',] }],
    animationDuration: [{ type: Input, args: ['animation-duration',] }],
    trigger: [{ type: Input, args: ['trigger',] }],
    tooltipClass: [{ type: Input, args: ['tooltip-class',] }],
    display: [{ type: Input, args: ['display',] }],
    displayTouchscreen: [{ type: Input, args: ['display-touchscreen',] }],
    offset: [{ type: Input, args: ['offset',] }],
    width: [{ type: Input, args: ['width',] }],
    maxWidth: [{ type: Input, args: ['max-width',] }],
    hideAfterClick: [{ type: Input, args: ['hide-after-click',] }],
    showDelay: [{ type: Input, args: ['show-delay',] }],
    hideDelay: [{ type: Input, args: ['hide-delay',] }],
    hideDelayAfterClick: [{ type: Input, args: ['hide-delay-after-click',] }],
    automationValue: [{ type: Input, args: ['tooltip-automation-value',] }],
    pointerEvents: [{ type: Input, args: ['pointer-events',] }],
    position: [{ type: Input, args: ['position',] }],
    tooltipId: [{ type: Input, args: ['tooltip-id',] }],
    tooltipContainer: [{ type: Input, args: ['tooltip-container',] }],
    events: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[aw-tooltip]',
                exportAs: 'aw-tooltip'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }, { type: ɵngcc0.Renderer2 }]; }, { events: [{
            type: Output
        }], options: [{
            type: Input,
            args: ['options']
        }], tooltipValue: [{
            type: Input,
            args: ['aw-tooltip']
        }], placement: [{
            type: Input,
            args: ['placement']
        }], autoPlacement: [{
            type: Input,
            args: ['auto-placement']
        }], contentType: [{
            type: Input,
            args: ['content-type']
        }], hideDelayMobile: [{
            type: Input,
            args: ['hide-delay-mobile']
        }], hideDelayTouchscreen: [{
            type: Input,
            args: ['hide-delay-touchscreen']
        }], zIndex: [{
            type: Input,
            args: ['z-index']
        }], animationDuration: [{
            type: Input,
            args: ['animation-duration']
        }], trigger: [{
            type: Input,
            args: ['trigger']
        }], tooltipClass: [{
            type: Input,
            args: ['tooltip-class']
        }], display: [{
            type: Input,
            args: ['display']
        }], displayTouchscreen: [{
            type: Input,
            args: ['display-touchscreen']
        }], offset: [{
            type: Input,
            args: ['offset']
        }], width: [{
            type: Input,
            args: ['width']
        }], maxWidth: [{
            type: Input,
            args: ['max-width']
        }], hideAfterClick: [{
            type: Input,
            args: ['hide-after-click']
        }], showDelay: [{
            type: Input,
            args: ['show-delay']
        }], hideDelay: [{
            type: Input,
            args: ['hide-delay']
        }], hideDelayAfterClick: [{
            type: Input,
            args: ['hide-delay-after-click']
        }], automationValue: [{
            type: Input,
            args: ['tooltip-automation-value']
        }], pointerEvents: [{
            type: Input,
            args: ['pointer-events']
        }], position: [{
            type: Input,
            args: ['position']
        }], tooltipId: [{
            type: Input,
            args: ['tooltip-id']
        }], tooltipContainer: [{
            type: Input,
            args: ['tooltip-container']
        }] }); })();

class AwTooltipOpenBehavior {
    constructor(tooltip) {
        this.tooltip = tooltip;
    }
    onMouseEnter() {
        this.tooltip.show();
    }
}
AwTooltipOpenBehavior.ɵfac = function AwTooltipOpenBehavior_Factory(t) { return new (t || AwTooltipOpenBehavior)(ɵngcc0.ɵɵdirectiveInject(AwTooltipDirective)); };
AwTooltipOpenBehavior.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwTooltipOpenBehavior, selectors: [["", "aw-tooltip", "", 3, "aw-toggletip", "", 3, "aw-focustip", ""]], hostBindings: function AwTooltipOpenBehavior_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function AwTooltipOpenBehavior_focusin_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseenter", function AwTooltipOpenBehavior_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); });
    } } });
AwTooltipOpenBehavior.ctorParameters = () => [
    { type: AwTooltipDirective }
];
AwTooltipOpenBehavior.propDecorators = {
    onMouseEnter: [{ type: HostListener, args: ['focusin',] }, { type: HostListener, args: ['mouseenter',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwTooltipOpenBehavior, [{
        type: Directive,
        args: [{
                selector: '[aw-tooltip]:not([aw-toggletip]):not([aw-focustip])'
            }]
    }], function () { return [{ type: AwTooltipDirective }]; }, { onMouseEnter: [{
            type: HostListener,
            args: ['focusin']
        }, {
            type: HostListener,
            args: ['mouseenter']
        }] }); })();

class AwToggletipOpenBehavior {
    constructor(tooltip) {
        this.tooltip = tooltip;
        this.tooltip.tooltipType = 'toggletip';
    }
    onMouseEnter() {
        this.tooltip.show();
    }
}
AwToggletipOpenBehavior.ɵfac = function AwToggletipOpenBehavior_Factory(t) { return new (t || AwToggletipOpenBehavior)(ɵngcc0.ɵɵdirectiveInject(AwTooltipDirective)); };
AwToggletipOpenBehavior.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwToggletipOpenBehavior, selectors: [["", "aw-tooltip", "", "aw-toggletip", "", 3, "aw-focustip", ""]], hostBindings: function AwToggletipOpenBehavior_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function AwToggletipOpenBehavior_click_HostBindingHandler() { return ctx.onMouseEnter(); });
    } } });
AwToggletipOpenBehavior.ctorParameters = () => [
    { type: AwTooltipDirective }
];
AwToggletipOpenBehavior.propDecorators = {
    onMouseEnter: [{ type: HostListener, args: ['click',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwToggletipOpenBehavior, [{
        type: Directive,
        args: [{
                selector: '[aw-tooltip][aw-toggletip]:not([aw-focustip])'
            }]
    }], function () { return [{ type: AwTooltipDirective }]; }, { onMouseEnter: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class AwFocustipOpenBehavior {
    constructor(tooltip) {
        this.tooltip = tooltip;
        this.tooltip.tooltipType = 'focustip';
    }
    onMouseEnter() {
        this.tooltip.show();
    }
}
AwFocustipOpenBehavior.ɵfac = function AwFocustipOpenBehavior_Factory(t) { return new (t || AwFocustipOpenBehavior)(ɵngcc0.ɵɵdirectiveInject(AwTooltipDirective)); };
AwFocustipOpenBehavior.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwFocustipOpenBehavior, selectors: [["", "aw-tooltip", "", "aw-focustip", "", 3, "aw-toggletip", ""]], hostBindings: function AwFocustipOpenBehavior_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function AwFocustipOpenBehavior_focusin_HostBindingHandler() { return ctx.onMouseEnter(); });
    } } });
AwFocustipOpenBehavior.ctorParameters = () => [
    { type: AwTooltipDirective }
];
AwFocustipOpenBehavior.propDecorators = {
    onMouseEnter: [{ type: HostListener, args: ['focusin',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwFocustipOpenBehavior, [{
        type: Directive,
        args: [{
                selector: '[aw-tooltip][aw-focustip]:not([aw-toggletip])'
            }]
    }], function () { return [{ type: AwTooltipDirective }]; }, { onMouseEnter: [{
            type: HostListener,
            args: ['focusin']
        }] }); })();

class AwTooltipDirectiveModule {
}
AwTooltipDirectiveModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwTooltipDirectiveModule });
AwTooltipDirectiveModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwTooltipDirectiveModule_Factory(t) { return new (t || AwTooltipDirectiveModule)(); }, imports: [[
            CommonModule,
            AwTooltipModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwTooltipDirectiveModule, { declarations: function () { return [AwTooltipDirective, AwTooltipOpenBehavior, AwFocustipOpenBehavior, AwToggletipOpenBehavior]; }, imports: function () { return [CommonModule,
        AwTooltipModule]; }, exports: function () { return [AwTooltipDirective, AwTooltipOpenBehavior, AwFocustipOpenBehavior, AwToggletipOpenBehavior]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwTooltipDirectiveModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AwTooltipModule
                ],
                declarations: [
                    AwTooltipDirective,
                    AwTooltipOpenBehavior,
                    AwFocustipOpenBehavior,
                    AwToggletipOpenBehavior
                ],
                exports: [
                    AwTooltipDirective,
                    AwTooltipOpenBehavior,
                    AwFocustipOpenBehavior,
                    AwToggletipOpenBehavior
                ]
            }]
    }], null, null); })();

export { AwFocustipOpenBehavior, AwToggletipOpenBehavior, AwTooltipDirective, AwTooltipDirectiveModule, AwTooltipOpenBehavior, ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };

//# sourceMappingURL=aw-ads-components-src-directives-aw-tooltip.js.map